import { Injectable, Provider } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ISidebarCartService, ISidebarCartServiceToken } from './sidebar-cart-service.interface';

@Injectable({
  providedIn: 'root'
})
export class SidebarCartService implements ISidebarCartService {
  private sidebarShoppingCartVisibilitySource: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private sidebarShoppingCartVisibilityChanged: Observable<boolean>;

  public constructor() {
    this.sidebarShoppingCartVisibilityChanged = this.sidebarShoppingCartVisibilitySource.asObservable();
  }

  public sidebarShoppingCartChangedGet(): Observable<boolean> {
    return this.sidebarShoppingCartVisibilityChanged;
  }

  public sidebarShoppingCartShow(): void {
    let isSideBarShoppingCartVisible = this.sidebarShoppingCartVisibilitySource.value;

    if (isSideBarShoppingCartVisible != true) {
      this.sidebarShoppingCartVisibilitySource.next(true);
    }
  }

  public sidebarShoppingCartHide(): void {
    let isSideBarShoppingCartVisible = this.sidebarShoppingCartVisibilitySource.value;

    if (isSideBarShoppingCartVisible == true) {
      this.sidebarShoppingCartVisibilitySource.next(false);
    }
  }

}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const SidebarCartServiceProvider: Provider[] = [
  { provide: ISidebarCartServiceToken, useExisting: SidebarCartService }
];
